import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Küldd el ezt a linket a cégnek. Csak egyszer használható.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { title: "Cégek" }, {
      text: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: $setup.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event)),
          label: "Keresés",
          "prepend-inner-icon": "mdi-magnify",
          variant: "outlined",
          "hide-details": "",
          "single-line": ""
        }, null, 8, ["modelValue"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "primary",
              "prepend-icon": "mdi-email-plus-outline",
              onClick: $setup.generateInvite,
              loading: $setup.inviteLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode("Meghívó generálása")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_data_table, {
          headers: $setup.headers,
          items: $props.companies,
          search: $setup.search
        }, {
          "item.actions": _withCtx(({ item }) => [
            _createVNode(_component_v_chip, {
              color: "blue",
              text: "Részletek",
              onClick: ($event: any) => ($setup.handleViewClick(item.id))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["items", "search"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: $setup.dialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.dialog) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { title: "Meghívó link" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.inviteLink,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inviteLink) = $event)),
                  variant: "outlined",
                  readonly: "",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: $setup.copyLink,
                  "prepend-icon": "mdi-content-copy"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Másolás")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.dialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Bezárás")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}